export const SEARCH_INPUT_TEST_ID = 'command-palette.ui.modal.header.search-input';
export const COMMAND_MODE_TEST_ID = 'command-palette.ui.modal.header.command-mode';
export const COMMAND_BACK_PARENT_TEST_ID = 'command-palette.ui.modal.header.left-arrow';
export const SPINNER_CONTAINER_TEST_ID = 'command-palette.ui.modal.header.spinner-container';
export const SEARCH_LOZENGE_TEST_ID =
	'command-palette.ui.modal.modal-content.header.search-lozenge';
